import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';
import { Base64UrlService } from '../../../services/base64url.service';

@Component({
  selector: 'tt-edi-source',
  templateUrl: './edi-source.component.html',
  styleUrls: ['./edi-source.component.css']
})
export class EdiSourceComponent implements OnInit {
    ediSourceKeyno;

    public edit?: Edit;

    public selectListExternalTypes: ExternalTypeItem[] = [];

    public selectListFtpAccounts: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private base64: Base64UrlService, private datatask: DataTaskService) {
        this.ediSourceKeyno = this.stateService.getStateParams()['edi_source_keyno'];
    }

    private async loadEdit() {
        if (!!this.ediSourceKeyno) {
            this.edit = (await this.datatask.Post(979, { edi_source_keyno: this.ediSourceKeyno }))[0];

            this.edit!.ftp_remotefolder = this.base64.Decode(this.edit!.ftp_remotefolder);
            this.edit!.ftp_localfolder = this.base64.Decode(this.edit!.ftp_localfolder);
            this.edit!.folder_localfolder = this.base64.Decode(this.edit!.folder_localfolder);
        }
    }

    private async loadExternalTypes() {
        this.selectListExternalTypes = await this.datatask.Post(980);
    }

    private async loadFtpAccounts() {
        this.selectListFtpAccounts = await this.datatask.Post(968);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(985, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadExternalTypes();
        this.loadFtpAccounts();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    edi_source_keyno: string;
    edi_source_type: string;
    edi_source_name: string;
    ftpaccount_keyno: string;
    ftp_remotefolder: string;
    ftp_localfolder: string;
    folder_localfolder: string;
    ws_endpoint: string;
    isactive: string;
}

interface ExternalTypeItem {
    edi_source_type: string;
    edi_source_type_name: string;
    orderby: number;
}
